// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.PageAccessTransfer_transferActions__Ea7em {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: stretch;
  align-self: center;
  gap: 8px;
  padding: 0 6px;
  min-width: 108px;
}
.PageAccessTransfer_transferActions__Ea7em > * {
  width: 100%;
}

@media (max-width: 1100px) {
  .PageAccessTransfer_transferActions__Ea7em {
    flex-direction: row;
    justify-content: center;
    align-items: center;
    width: 100%;
    min-width: 0;
    padding: 12px 0;
  }
  .PageAccessTransfer_transferActions__Ea7em > * {
    width: auto;
    min-width: 108px;
  }
}`, "",{"version":3,"sources":["webpack://./src/views/pages/UserProfiles/PageAccessTransfer.module.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,oBAAA;EACA,kBAAA;EACA,QAAA;EACA,cAAA;EACA,gBAAA;AACF;AACE;EACE,WAAA;AACJ;;AAGA;EACE;IACE,mBAAA;IACA,uBAAA;IACA,mBAAA;IACA,WAAA;IACA,YAAA;IACA,eAAA;EAAF;EAEE;IACE,WAAA;IACA,gBAAA;EAAJ;AACF","sourcesContent":[".transferActions {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: stretch;\n  align-self: center;\n  gap: 8px;\n  padding: 0 6px;\n  min-width: 108px;\n\n  > * {\n    width: 100%;\n  }\n}\n\n@media (max-width: 1100px) {\n  .transferActions {\n    flex-direction: row;\n    justify-content: center;\n    align-items: center;\n    width: 100%;\n    min-width: 0;\n    padding: 12px 0;\n\n    > * {\n      width: auto;\n      min-width: 108px;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"transferActions": `PageAccessTransfer_transferActions__Ea7em`
};
export default ___CSS_LOADER_EXPORT___;
